// extracted by mini-css-extract-plugin
export var closeButton = "_nh-1";
export var closeX = "_nh-3";
export var container = "_nh-0";
export var image = "_nh-2";